/**
 * check if the email is valid
 * @param mail 
 */
export const checkEmailRegex = (mail: string) => {

    const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

    return emailRegex.test(mail);
}